import { DateFormatType } from "@/models/date-format-type.model";

export class UtilService {

    toFormattedDateTime(dateStr?: string, format?: DateFormatType): string | null {
        if (!dateStr)
            return null;

        const date = new Date(dateStr);

        const year = date.getFullYear();
        const month = this.leftFixedWithZero((date.getMonth() + 1), 2);
        const day = this.leftFixedWithZero(date.getDate(), 2);
        const hour = this.leftFixedWithZero(date.getHours(), 2);
        const minute = this.leftFixedWithZero(date.getMinutes(), 2);
        const second = this.leftFixedWithZero(date.getSeconds(), 2);
        const millisecond = this.leftFixedWithZero(date.getMilliseconds(), 3);

        switch (format) {
            case DateFormatType.Year:
                return `${year}`;

            case DateFormatType.Month:
                return `${year}-${month}`;

            case DateFormatType.Day:
                return `${year}-${month}-${day}`;

            case DateFormatType.Hour:
                return `${year}-${month}-${day} ${hour}`;

            case DateFormatType.Minute:
                return `${year}-${month}-${day} ${hour}:${minute}`;

            case DateFormatType.Second:
                return `${year}-${month}-${day} ${hour}:${minute}:${second}`;

            case DateFormatType.Millisecond:
                return `${year}-${month}-${day} ${hour}:${minute}:${second}.${millisecond}`;

            default:
                return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        }
    }

    toFormattedNumString(num: number, maximumFractionDigits = 0) {
        if (!num)
            return num;

        return num.toLocaleString('en-US', { maximumFractionDigits: maximumFractionDigits });
    }

    leftFixedWithZero(num: number, targetLength: number) {
        return num.toString().padStart(targetLength, '0');
    }
}

const utilService = new UtilService();
export default utilService;